var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomework(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1967 23.9169H10.8901V14.6081L17.0434 9.85156L23.1967 14.6081V23.9169Z",
    stroke: "#D97706",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.042 12.4307L17.0431 7.08301L23.9579 12.4307",
    stroke: "#D97706",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9966 16.4238H21.0486",
    stroke: "#D97706",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9966 18.9663H21.0486",
    stroke: "#D97706",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9966 21.5146H21.0486",
    stroke: "#D97706",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    stroke: "#D97706"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 19,
    fill: "white",
    transform: "translate(9 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomework);
export default __webpack_public_path__ + "static/media/homework.8f01f85e81eee4e82b41acfaace66556.svg";
export { ForwardRef as ReactComponent };